export const NAME = 'Pujcovna';
export const DMS_MODULE = 'Pujcovna';

export const CRUMB_LABEL_KEY = 'repVozidlopa';
